var scope_0 = require('/zeit/65455518/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/90cab58d1c01d935c7cf53f261280c68.js').default;export default
        Object.assign({}, scope_0 )
    